import { forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Col, Row, message } from 'antd';
import PreloadedImage from 'ReusableComponents/PreloadedImage';

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, language } = props,
    { required, questions, defaultValue, id, mediaFiles } = inputData,
    { getFieldDecorator } = form;

  return (
    <FormItem>
      {getFieldDecorator(id, {
        initialValue: defaultValue,
        rules: [
          {
            required,
            message: "Required Field"
          }
        ]
      })(
        <Row type="flex" justify="center" align="middle">
          <Col span={6}>
            <PreloadedImage width={"100%"} image={mediaFiles[0].src} />
          </Col>
        </Row>
      )}
    </FormItem>
  );
});
